import BoldSmallText from '@/components/BoldSmallText'
import RegularText from '@/components/RegularText'
import { Box } from '@shopify/polaris'
import { useTranslation } from 'react-i18next'
import AppModal from '../../../../components/AppModal/AppModal'

type TModalDuplicateLocation = {
  isShowModal: boolean
  onAction: () => void
  onCancel: () => void
  loading?: boolean
}

const ModalDuplicateLocation = ({ isShowModal, onAction, onCancel, loading }: TModalDuplicateLocation) => {
  const { t } = useTranslation('locations')
  return (
    <AppModal
      title={t('modalDuplicate.duplicateLocation')}
      open={isShowModal}
      onCancel={onCancel}
      submitText={t('modalDuplicate.duplicate')}
      cancelText={t('modalDuplicate.cancel')}
      onSubmit={onAction}
      loading={loading}
    >
      <Box padding={'400'}>
        <RegularText as='p'>
          {t('modalDuplicate.textAnnotation')} <BoldSmallText as="strong">{t('modalDuplicate.textWithout')}</BoldSmallText>
        </RegularText>
        <br />
        <BoldSmallText>{t('modalDuplicate.textAnnotationStrong')}.</BoldSmallText>
      </Box>
    </AppModal>
  )
}

export default ModalDuplicateLocation
